import React from 'react'
import Icon from './icon'

const Warning = ({ viewBox = '0 0 86.62 73.21', style, stroke }) => {
  return (
    <Icon viewBox={viewBox} style={style} stroke={stroke}>
      <path
        d="M91.2,70.5l-33-52.3a10.28,10.28,0,0,0-17.4,0L8,70.5v.1a10,10,0,0,0-1.4,5.1A10.24,10.24,0,0,0,16.8,85.9H82.3A10.24,10.24,0,0,0,92.5,75.7,9.59,9.59,0,0,0,91.2,70.5Zm-8.8,9.4H16.8a4.23,4.23,0,0,1-4.2-4.2,4.55,4.55,0,0,1,.5-2L46,21.5a4.24,4.24,0,0,1,7.2,0L86.1,73.6a3.64,3.64,0,0,1,.5,2.1A4.23,4.23,0,0,1,82.4,79.9Z"
        transform="translate(-6.25 -13.05)"
      />
      <path
        d="M49.6,66.4a3.85,3.85,0,0,0-2.9,1.2,4,4,0,0,0-1.2,2.9,3.54,3.54,0,0,0,1.3,3,4.37,4.37,0,0,0,5.8,0,3.77,3.77,0,0,0,1.2-3,4,4,0,0,0-1.2-2.9A4.41,4.41,0,0,0,49.6,66.4Z"
        transform="translate(-6.25 -13.05)"
      />
      <path
        d="M49.8,32.9a4.08,4.08,0,0,0-3.2,1.3,5.05,5.05,0,0,0-1.2,3.6c0,1.1.1,3,.2,5.5l.9,13.2a12.92,12.92,0,0,0,.8,3.8,2.23,2.23,0,0,0,2.1,1.3,2.08,2.08,0,0,0,2.1-1.3,10.75,10.75,0,0,0,.8-3.7L53.6,43c.1-1.3.2-2.5.2-3.7a11.37,11.37,0,0,0-.8-4.7A3.14,3.14,0,0,0,49.8,32.9Z"
        transform="translate(-6.25 -13.05)"
      />
    </Icon>
  )
}

export default Warning



// WEBPACK FOOTER //
// ./src/components/Icons/warning.js